/**
 * External Dependencies
 */
import './core/utils.js';
import './core/query.js';
import Tastet from './tastet.js';
import Page from './core/page.js';

Tastet.ready(function () {
  console.log('Tastet ready');
  Page.create();
});
